import { Component, OnInit } from '@angular/core';
import {GridOptions} from "ag-grid/main";
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { CatalogosService} from '../../catalogos/catalogos.service'

@Component({
  selector: 'app-select-location',
  templateUrl: './select-location.component.html',
  styleUrls: ['./select-location.component.css']
})

export class SelectLocationComponent implements OnInit {
	
  gridOptions: any;
	loading: boolean = true;
	userData: any;
	data: any;
	auxData: any;
	auxLocation: any;
	gridApi: any;
	gridColumnApi: any;
  
  constructor(public catalogosService: CatalogosService,public dialogRef: MatDialogRef<SelectLocationComponent>) { 
  	this.gridOptions = <GridOptions>{
      rowData: this.data,
      floatingFilter: true,
      columnDefs: SelectLocationComponent.createColumnDefs(),
      context: {
          componentParent: this
      }
	  };
  }  

  ngOnInit() {
  	let userInfo = JSON.parse( localStorage.getItem('userInfo'))
    this.userData = {
      user_id: userInfo.usuario_id,
      client_id : userInfo.cliente_id
      }      
  	this.viewLocations()
  }

  private static createColumnDefs() {
    return [              
      {
        headerName: "Selección",
        headerCheckboxSelection: true,
        checkboxSelection: true,
        field: "selection",
        colId: "selection", 
        suppressFilter: true,
      },{
        headerName: "Ubicacion",
        field: "code_planta",  
        colId: "code_planta",                                            
      },{
        headerName: "Cluster",
        field: "cluster",  
        colId: "cluster",                                            
      },{
        headerName: "Región",
        field: "region",  
        colId: "region",                                            
      },{
        headerName: "Distribuidora",
        field: "distribuidora",  
        colId: "distribuidora",     
      }
    ];
  }  

   onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    params.api.sizeColumnsToFit();
    params.api.sizeColumnsToFit();
    window.addEventListener("resize", function() {
      setTimeout(function() {
        params.api.sizeColumnsToFit();
      });
    });
    /*this.gridApi.forEachNode( function(node) {
      // select the node
      if (node.data.id == this.inputData.id) {
        node.setSelected(true);
      }      
    });*/
  }

  refreshData(){
    this.loading = true
    this.viewLocations()
  }

  viewLocations(){
    /* this.filterService.getLocationsAll(this.userData.user_id)
    .subscribe((response:any)=>{
      if (response.success){
        this.data = response.data
        this.auxLocation = response.data
        this.loading= false        
      }
    }
    
    ); */

    this.catalogosService.getCatalogPlantasUsuario({ user_id : this.userData.user_id}, '/plantas')
    .subscribe((res:any) => {  
        if (res.success) { 
          this.data = res.data
          this.loading= false    
        }
      });
  }
  
  onRowSelected(event){
    this.dialogRef.close(event.data)
  }
}